import { useRouter } from 'next/router';
import { useEffect } from 'react';
import useSession from '../../services/store/session-store';

const ConsentCheck: React.FC<any> = ({ children }) => {
  const session = useSession();
  const { replace: routerReplace, pathname } = useRouter();

  useEffect(() => {
    if (
      session?.iamPrincipal &&
      pathname !== '/consents' &&
      session?.discoveryParams?.organizationSettings?.security_consents_needed === true &&
      session?.iamPrincipal?.security?.security_consents_approved === false
    ) {
      routerReplace(`/consents?redirect_to=${pathname}`);
    }
  }, [pathname, routerReplace, session?.discoveryParams?.organizationSettings?.security_consents_needed, session?.iamPrincipal]);

  return children;
};

export default ConsentCheck;
